import { Toast } from '../../../../components/Common/Toast';
import { CONFIG } from '../../../../config/mainConfig';
import { HTTPStatusEnum } from '../../../../interfaces/log.interface';
import { callAPI } from '../../../../services/api.service';

export const getPaymentHistoryDetails = async (email: string, currentPage: number) => {
  try {
    const response = await callAPI(
      `user/get-user-payment-history?email=${email}&pageNumber=${currentPage}`
    );

    if (response?.status === HTTPStatusEnum.OK) {
      return { payments: response.payments, totalPages: response.totalPages };
    } else {
      Toast('Something Went Wrong', true);
      return { payments: [], totalPages: null };
    }
  } catch (error) {
    Toast('Something Went Wrong', true);
    return { payments: [], totalPages: null };
  }
};
